import React from "react";
import { Container, Breadcrumb, Row, Col, Card, Button } from "react-bootstrap";
import { ACCESSREQUEST_URL } from "../../../../../constants/serverConfig";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import {
  qualityclr,
  SAVIYANT_HELP_URL,
  SAVIYANT_URL,
} from "../../../../../constants/Constant";
import { IoHelpCircleSharp } from "react-icons/io5";

const BreadcrumbBar = (props) => {
  const bardata = props.bardata;
  const metricclr = props.metricclr;
  const ifMetricPage = props.ifMetricPage;
  const from = props.from;

  const params = useParams();
  const datasetidfetch = props.datasetdata;

  let navigate = useNavigate();

  const datasetid = _.uniq(
    _.map(
      _.filter(
        datasetidfetch,
        (iddata) => iddata.dataset_id === `${params.id}`
      ),
      "dataset_id"
    )
  );

  return (
    <div className="viewall__breadcrumb__main">
      <Card className="breadcrumb__card">
        <Row className="px-51">
          <Col xs={8} lg={8} className="pt-1">
            <Breadcrumb>
              <Breadcrumb.Item className="pe-auto" href="/">
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                className="pe-auto"
                // onClick={props.backToLandingPage}
                onClick={() => navigate(-1)}
              >
                { ifMetricPage ? "Metric" : "Datasets"}
              </Breadcrumb.Item>
              {/* {(from !== null || from !== undefined) && from === "viewall" ? (
                <Breadcrumb.Item href="/databook/viewalldatasets">
                  {from}
                </Breadcrumb.Item>
              ) : (
                ""
              )} */}
              <Breadcrumb.Item active>
                {/* <span>{datasetid}</span> */}
                <span>{props.modaldata.fqn}</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {props?.saviyantacess ? (
            <Col className="access__accuracy " xs={4} lg={4}>
              <div className="d-flex float-end">
                <div className="d-table">
                  <span
                    onClick={() => window.open(SAVIYANT_HELP_URL, "_blank")}
                    className="px-1 saviyant-help d-table-cell align-middle"
                  >
                    {" "}
                    Saviynt help <IoHelpCircleSharp />
                  </span>
                </div>
                <div className="d-inline-block px-2">
                  <Button
                    className="governace-access"
                    onClick={() => window.open(SAVIYANT_URL, "_blank")}
                  >
                    Request data access
                  </Button>
                </div>
                {bardata && bardata?.length > 0 ? (
                  <div className="col-xs-1 text-center">
                    <div
                      className="text-center quality__tab"
                      style={{
                        backgroundColor: qualityclr[metricclr],
                        float: "right",
                      }}
                    >
                      <span className="header__metric">{bardata}%</span>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Card>
    </div>
  );
};

export default BreadcrumbBar;
